import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';

// utility function to transform an array of metadata to an object that maps them by name
export default metaData =>
  metaData && mapValues(groupBy(metaData, 'name'), x => x[0]);
